/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Models_Hint_Stream_ErrorInputs */



/**
* | output |
* | --- |
* | "The server reported an error while answering." |
*
* @param {Private_Models_Hint_Stream_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_hint_stream_error = /** @type {((inputs?: Private_Models_Hint_Stream_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Hint_Stream_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Server hat beim Antworten einen Fehler gemeldet.")
	return /** @type {LocalizedString} */ ("The server reported an error while answering.")
});